import Vue from 'vue'
import VueI18n from 'vue-i18n'
// 引入语言包
import en from './en/index'
import zh from './zh/index'

Vue.use(VueI18n)
const messages = {
    en,
    zh
}
// 配置i18n
const i18n = new VueI18n({
    locale: sessionStorage.getItem('lang') || 'en', // 从缓存中获取当前的语言类型
    messages
})
export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js